








































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  EntityServiceTransaction,
  ServiceTransactionInitState, ServiceTransactionStatus
} from '@/store/service-transaction/service-transaction.types';
import {Helper} from '../../../util/helper';
import BgTheme1 from '@/components/bg-theme-1.vue';

@Component({
  components: {
    BgTheme1
  }
})
export default class HistoryActivityComponent extends Vue {

  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getServiceTransactionHistoryList', {namespace: 'serviceTransaction'}) getServiceTransactionHistoryList!: () => Promise<void>;

  public listTransactionHistory = [] as EntityServiceTransaction[];
  public lib: Helper = new Helper();

  async mounted() {
    await this.Loading(true);
    await this.getServiceTransactionHistoryList();
    this.listTransactionHistory = this.serviceTransactionInitState.serviceTransactionHistory;
    await this.Loading(false);

  }

  async nextEvent(ServiceTransaction: EntityServiceTransaction) {

    if (ServiceTransaction.serviceTransactionStatus === ServiceTransactionStatus.Done) {
      this.$router.push({
        path: '/payment-final-information',
        query: {
          id: ServiceTransaction.id
        }
      }).then();
    } else if (ServiceTransaction.serviceTransactionStatus === ServiceTransactionStatus.Running || ServiceTransaction.serviceTransactionStatus === ServiceTransactionStatus.FinalCodeGenerated) {
      this.$router.push({
        path: '/payment-information',
        query: {
          id: ServiceTransaction.id
        }
      }).then();
    } else {
      this.$router.push({
        path: `/activity/${ServiceTransaction.id}`
      }).then();
    }


  }

}
